import type { TemplatePack } from './interpretation.js';

export const INTERP_COMMON_TEMPLATE_PACK_0_2_0: TemplatePack = Object.freeze({
  id: 'TEMPLATE-COMMON-ZHTW',
  version: '0.2.0',
  templates: Object.freeze({
    'personality.decisiveness.wuqu': Object.freeze({
      key: 'personality.decisiveness.wuqu',
      variants: Object.freeze([
        '依傳統紫微斗數的星性描述，命宮見武曲可作為行事較果決的傾向訊號；判讀強度仍需結合星曜亮度與其他宮星關係。',
        '以傳統紫微斗數觀點來看，武曲在命宮可支持較重視決斷與效率的傾向；仍不能脫離廟旺、同宮與相關宮位條件單獨定論。',
        '傳統命理對武曲有偏向果決的描述；本系統只把它列為一項人格 Evidence，並依亮度與其他獨立證據決定強弱。',
      ]),
    }),
    'personality.adaptability.tianji': Object.freeze({
      key: 'personality.adaptability.tianji',
      variants: Object.freeze([
        '依《紫微斗數全書》的傳統描述，命宮見天機可作為應變、思考與做事有方的傾向訊號；廟旺等條件只作加權，不單獨定論。',
        '傳統紫微斗數將天機與靈活應變、作事有方連結；本系統把它視為適應與規劃能力的一項 Evidence，仍需與其他宮星條件交叉判讀。',
        '以傳統命理框架來看，天機在命宮可支持較善於因應變化與思考方法的傾向；是否明顯仍取決於亮度與其他獨立證據。',
      ]),
    }),
    'personality.gentleness.tiantong': Object.freeze({
      key: 'personality.gentleness.tiantong',
      variants: Object.freeze([
        '《紫微斗數全書》以謙遜、溫和等語描述天同；命宮見天同可作為較和緩、不偏激的一項人格 Evidence，仍需其他條件交叉確認。',
        '以傳統紫微斗數觀點，天同在命宮可支持謙和、溫和的傾向；本系統不把單一星曜直接等同完整人格。',
        '天同的古籍星性包含謙遜與溫和，本系統將其抽象為較柔和的互動傾向訊號，並保留其他星曜可能形成的反向 Evidence。',
      ]),
    }),
    'personality.refinement.taiyin': Object.freeze({
      key: 'personality.refinement.taiyin',
      variants: Object.freeze([
        '傳統《紫微斗數全書》描述太陰有聰明、端雅純祥的性情傾向；命宮見太陰可作為細緻與端穩的一項人格 Evidence。',
        '以傳統紫微斗數框架來看，太陰在命宮可支持較細膩、端穩的傾向；亮度與其他星曜仍會影響最後判讀。',
        '太陰的古籍描述包含聰明與端雅，本系統把它轉成細緻／端穩維度的候選訊號，而不是固定人格標籤。',
      ]),
    }),
    'personality.generosity.taiyang': Object.freeze({
      key: 'personality.generosity.taiyang',
      variants: Object.freeze([
        '《紫微斗數全書》對太陽有聰明、慈愛與量寬的傳統描述；命宮見太陽可作為較開朗寬厚的一項人格 Evidence。',
        '以傳統命理框架而言，太陽在命宮可支持較寬厚、願意承擔與外向表達的傾向；仍不能脫離亮度與其他宮星條件。',
        '太陽的古籍星性帶有慈愛與度量較寬的描述，本系統將其作為寬厚度的一項候選訊號，而非確定的人格判決。',
      ]),
    }),
    'personality.composure.tianfu': Object.freeze({
      key: 'personality.composure.tianfu',
      variants: Object.freeze([
        '傳統《紫微斗數全書》形容天府之性偏溫良端雅；命宮見天府可作為沉穩、和緩的一項人格 Evidence，但不以單星直接下完整結論。',
        '以傳統紫微斗數觀點，天府在命宮可支持溫和、端穩的傾向；本系統仍會等待其他宮星與四化證據來確認強弱。',
        '天府的傳統星性包含溫良與端雅，本系統將其轉成「較重視穩定與和緩」的候選訊號，而非確定的人格標籤。',
      ]),
    }),
    'personality.fairness.tianxiang': Object.freeze({
      key: 'personality.fairness.tianxiang',
      variants: Object.freeze([
        '《紫微斗數全書》對天相有誠實、惻隱與抱不平的傳統描述；命宮見天相可作為公平感與同理傾向的一項 Evidence。',
        '以傳統命理框架而言，天相在命宮可支持重視誠信、公平與他人處境的傾向；仍須結合其他星曜與宮位條件。',
        '天相的古籍描述包含不喜虛偽、見難有惻隱等特徵，本系統只將其轉為公平／同理維度的候選訊號，不作道德定性。',
      ]),
    }),
    'personality.integrity.tianliang': Object.freeze({
      key: 'personality.integrity.tianliang',
      variants: Object.freeze([
        '傳統《紫微斗數全書》以磊落、循直無私與穩重描述天梁；命宮見天梁可作為重原則、較穩健的一項人格 Evidence。',
        '以傳統紫微斗數觀點，天梁在命宮可支持較重原則、處事穩健的傾向；本系統仍要求其他獨立證據才能提高判讀強度。',
        '天梁的傳統星性包含磊落、溫謙與臨事果決，本系統將其抽象為原則感與穩健度的候選訊號，而非固定人格結論。',
      ]),
    }),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_1_0 = INTERP_COMMON_TEMPLATE_PACK_0_2_0;


export const INTERP_COMMON_TEMPLATE_PACK_0_3_0: TemplatePack = Object.freeze({
  id: 'TEMPLATE-COMMON-ZHTW',
  version: '0.3.0',
  templates: Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_2_0.templates,
    'personality.coordination.ziwei_assistants': Object.freeze({
      key: 'personality.coordination.ziwei_assistants',
      variants: Object.freeze([
        '《紫微斗數全書》把紫微與左輔、右弼的同宮或三方會合作為重要組合；本系統只將其現代化為較容易形成協調、支援與組織互動條件的傳統命理訊號，不代表現實地位或成就。',
        '依傳統紫微斗數的組合觀點，命宮紫微同時得到左輔、右弼在本宮或三方四正呼應，可增加「有人協作、較能整合資源」的 Evidence；這裡不沿用古代身分與成就判語。',
        '紫微與輔弼形成同宮／三方四正組合時，古籍給予較高重視；本系統將它縮減為協調與支援條件的一項 context Evidence，仍須與其他宮位、四化和反向條件一起判讀。',
      ]),
    }),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_4_0: TemplatePack = Object.freeze({
  id: 'TEMPLATE-COMMON-ZHTW',
  version: '0.4.0',
  templates: Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_3_0.templates,
    'wealth.resource_management.wuqu': Object.freeze({
      key: 'wealth.resource_management.wuqu',
      variants: Object.freeze([
        '依《紫微斗數全書》財帛宮的傳統脈絡，財帛宮見武曲可作為較重視資源、收支與實際管理方式的一項 Evidence；這不是投資報酬或財富結果的預測。',
        '傳統紫微斗數在財帛宮特別重視武曲；本系統只將其現代化為對資源配置、效率與財務秩序較敏感的候選訊號，不推導現實收入或投資結果。',
        '財帛宮武曲在古籍中有明確財務脈絡；本系統把它縮減為「資源管理方式」的一項低強度傳統命理訊號，仍需四化、三方與其他獨立 Evidence 才能提高強度。',
      ]),
    }),
    'career.organization.ziwei': Object.freeze({
      key: 'career.organization.ziwei',
      variants: Object.freeze([
        '依《紫微斗數全書》官祿宮的傳統脈絡，官祿宮見紫微可作為較重視責任、整合與組織角色的一項 Evidence；這不代表現實職位、錄取或升遷結果。',
        '傳統紫微斗數把官祿宮紫微放在承擔與組織脈絡中；本系統只抽象為較可能重視協調、責任與資源整合的候選訊號，仍需廟旺與其他星曜條件交叉判讀。',
        '官祿宮紫微在古籍中常與組織責任及協調條件一起判讀；本系統將其保留為一項職涯 context Evidence，而不是職業成就或收入的確定預測。',
      ]),
    }),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_5_0: TemplatePack = Object.freeze({
  id: 'TEMPLATE-COMMON-ZHTW',
  version: '0.5.0',
  templates: Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_4_0.templates,
    'relationship.partner_coordination.spouse': Object.freeze({
      key: 'relationship.partner_coordination.spouse',
      variants: Object.freeze([
        '依《紫微斗數全書》夫妻宮的傳統條件，本系統只整理「協作較順」與「協調阻力增加」兩類 Evidence；這些訊號描述互動 context，不代表關係成敗、婚期或長久程度。',
        '夫妻宮的輔弼、天梁及相關阻力星曜在古籍中有不同互動脈絡；本系統只把它們保留成伴侶協作／磨合條件的支持或反向 Evidence，不延伸成關係結果判定。',
        '感情主題目前只輸出可追溯的夫妻宮協調 Evidence；支持與反向條件會同時保留，不據此推論婚姻結果或事件發生。',
      ]),
    }),
    'family.sibling_coordination.context': Object.freeze({
      key: 'family.sibling_coordination.context',
      variants: Object.freeze([
        '家庭主題目前只導入已核對的手足互動 Evidence：支持、依靠與協調阻力會分開保留；父母與子女相關規則仍在研究中，不以古代高風險斷語補足。',
        '依卷二兄弟宮的可安全轉譯條件，本系統只整理手足之間可能較有支持或較需協調的 context；不使用手足人數、性別或家庭結果判語，父母與子女規則另行研究。',
        '這項 Family Evidence 僅代表兄弟姊妹宮的傳統互動條件，並保留亮度造成的支持／反向訊號；它不是整個家庭關係的總結，父母與子女規則仍另行研究。',
      ]),
    }),
    'social.support_network.tianfu': Object.freeze({
      key: 'social.support_network.tianfu',
      variants: Object.freeze([
        '古籍「奴僕宮」與現代人際關係並不等義；本系統只把其中天府的「得力」脈絡謹慎轉成協作／支援網絡的一項低強度 Evidence，不保留主僕階級語義。',
        '在人際主題中，本系統把歷史上的奴僕宮僅作「合作與支援網絡」的近似 context；天府在此只支持較容易形成可用協作資源的傳統訊號，不能代表友情品質。',
        '此人際 Evidence 來自古代奴僕宮條文的現代化抽象，只描述支援／協作網絡 context；不把古代主僕關係直接套用到現代朋友或同事。',
      ]),
    }),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_6_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.6.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_5_0.templates,
    'wealth.resource_stewardship.tianfu':Object.freeze({key:'wealth.resource_stewardship.tianfu',variants:Object.freeze([
      '財帛宮天府在古籍中帶有保守與積聚脈絡；本系統只把它轉成資源保管、配置與留有餘裕的一項 Evidence。若同宮又有阻力星曜，反向 Evidence 會同時保留。',
      '依《紫微斗數全書》財帛宮天府條，本系統將其現代化為較重視資源秩序與穩定配置的傳統訊號，不代表收入、資產或投資結果。',
      '天府落財帛宮可支持較偏向保守管理、累積與調度資源的 context；這只是規則式文化判讀，仍要與四化、三方及反向條件一起看。',
    ])}),
    'wealth.resource_retention.taiyin':Object.freeze({key:'wealth.resource_retention.taiyin',variants:Object.freeze([
      '財帛宮太陰的古籍條文明確區分廟旺與陷地；本系統只轉成資源留存／積累穩定度的支持或反向 Evidence，不預測財富高低。',
      '太陰在財帛宮且亮度有力時，可增加資源留存較有秩序的傳統訊號；亮度偏弱時則保留相反 Evidence，但不直接推論任何損失結果。',
      '這項太陰 Evidence 只描述資源保存與累積方式的 context，強弱取決於亮度與其他獨立條件，不作收入或投資報酬判斷。',
    ])}),

    'career.role_stability.tianfu':Object.freeze({key:'career.role_stability.tianfu',variants:Object.freeze([
      '官祿宮天府在古籍中重視入廟與空劫等條件；本系統只抽象為承接制度化、穩定角色的一項支持／反向 Evidence，不代表職位或升遷結果。',
      '天府在官祿宮且亮度有力時，可支持較重秩序、承接與穩定運作的職涯 context；若同宮見空劫，則保留降低穩定度的 counter Evidence。',
      '這項職涯判讀只描述傳統命理中的角色穩定與組織 context，不對錄取、升遷、薪資或職稱作確定預測。',
    ])}),
    'social.support_network.taiyin':Object.freeze({key:'social.support_network.taiyin',variants:Object.freeze([
      '古籍奴僕宮與現代朋友並不等義；本系統只把太陰廟／陷差異轉成合作與支援網絡可用度的一項支持或反向 Evidence。',
      '太陰落在歷史上的奴僕宮且亮度有力時，可支持較容易形成可用協作網絡的傳統訊號；亮度偏弱時只表示這項 Evidence 較弱，不評價他人的可靠性或關係結果。',
      '這項人際 Evidence 僅近似描述合作／支援網絡 context，並保留亮度造成的正反條件；不把古代主僕語義直接套用到現代朋友或同事。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_7_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.7.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_6_0.templates,
    'personality.centeredness.ziwei':Object.freeze({key:'personality.centeredness.ziwei',variants:Object.freeze([
      '《紫微斗數全書》對命宮紫微有「厚重」的星性描述；本系統只把它轉成較沉穩、重秩序的一項人格 Evidence，並與其他宮星條件交叉判讀。',
      '命宮紫微在古籍中帶有樞紐與厚重的意象；產品只抽象為較能維持中心感、秩序感與穩定表現的低強度傳統訊號。',
      '紫微在命宮可支持較沉著、重結構的一項傳統人格 context；其強弱仍需亮度、同宮與三方四正等其他獨立 Evidence 交叉判讀。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_8_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.8.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_7_0.templates,
    'timing.core_layer.life_focus_convergence':Object.freeze({key:'timing.core_layer.life_focus_convergence',variants:Object.freeze([
      '卷三要求大限、小限與太歲分層查看後再交叉合參；當其中兩個核心時間層對本命命宮的宮位映射一致，本系統只標示為「跨層焦點收斂」，表示同一結構值得優先觀察，不作事件結果預測。',
      '大限、小限、流年之間若對本命命宮出現相同宮位映射，可視為多層結構重複的一項 Evidence；這只提高該結構的觀察優先度，不代表某種現實結果。',
      '這項 Timing Evidence 表示至少兩個核心運限層在命宮焦點上重合；系統保留各層原始 Evidence 與來源，不把重合換算成分數、機率或單一事件結論。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_9_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.9.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_8_0.templates,
    'home.stewardship.tianfu':Object.freeze({key:'home.stewardship.tianfu',variants:Object.freeze([
      '田宅宮天府在《紫微斗數全書》中帶有守成、自置與維持的脈絡；本系統只把它轉成較重視居住空間穩定、整理與長期維護的一項 Evidence。若同宮有阻力條件，反向 Evidence 會一起保留。',
      '傳統田宅宮天府條重視穩定與延續；產品只抽象為居住／空間管理較偏向維護秩序與持續配置的文化性訊號，不預測房產價值、持有數量或購屋結果。',
      '這項田宅 Evidence 只描述對居住環境與長期空間維護的傳統 context；支持與反向條件會並列，不作不動產投資、買賣或資產結果建議。',
    ])}),
    'wellbeing.rest_rhythm.tianji':Object.freeze({key:'wellbeing.rest_rhythm.tianji',variants:Object.freeze([
      '福德宮天機在古籍中有「先勞後逸」的節奏描述；本系統只將它抽象為較可能先投入、再需要回復與切換動靜的一項內在節奏 Evidence，不代表心理健康或幸福程度。',
      '傳統福德宮天機條呈現先動後靜、忙後求穩的脈絡；產品只把它視為休息與內在節奏的一項文化性訊號，並保留其他星曜可能形成的反向 Evidence。',
      '這項福德 Evidence 只描述傳統命理中的動靜／回復節奏；若同宮出現阻力條件，系統會同時顯示較難維持安定節奏的 counter Evidence，不作失眠、焦慮、疾病或壽命判斷。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_10_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.10.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_9_0.templates,
    'personality.life_transformation.context':Object.freeze({key:'personality.life_transformation.context',variants:Object.freeze([
      '《紫微斗數全書》卷三把命宮的廟旺與化吉／化忌列在核心判讀第一層；本系統只把命宮生年四化視為需要與星曜、亮度及三方四正一起看的 Evidence。祿／權／科提供支持脈絡，化忌則保留為反向依據，不作現實結果預測。',
      '命宮生年四化在傳統判讀中屬於核心結構之一；產品將祿、權、科與忌拆成可追溯的支持／counter Evidence，讓同一命盤的正反條件並列，而不是換算成吉凶分數、成功率或事件機率。',
      '這項 Evidence 只表示命宮四化條件值得提高判讀優先度：祿／權／科與化忌分別保留為不同方向的判讀依據，仍需與命宮星曜、亮度和三方四正共同解讀。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_11_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.11.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_10_0.templates,
    'wellbeing.transformation.context':Object.freeze({key:'wellbeing.transformation.context',variants:Object.freeze([
      '《紫微斗數全書》卷三要求福德宮合看權、祿、劫空與廟陷；本系統只把福德宮生年化祿／化權列為內在節奏與福德結構的一項支持 Evidence，仍需和星曜、亮度及其他條件一起判讀。',
      '福德宮的祿／權在傳統判讀中屬於需要合參的結構條件；產品只保留成可追溯的支持 Evidence，不換算為幸福分數、心理狀態、壽命或事件機率。',
      '這項 Evidence 只表示福德宮生年化祿／化權值得納入合參；它不代表休息品質、心理健康或人生結果，並應與劫空、亮度及宮內星曜等其他證據共同閱讀。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_12_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.12.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_11_0.templates,
    'wealth.transformation.context':Object.freeze({key:'wealth.transformation.context',variants:Object.freeze([
      '《紫微斗數全書》卷三把權祿與劫空都列入財福結構；本系統只把財帛宮生年化祿／化權視為資源管理的一項支持 Evidence，若同時見地空／地劫則保留反向 Evidence，不預測收入或投資結果。',
      '財帛宮祿／權與劫空在傳統條文中都屬需合參條件；產品將它們拆成可追溯的支持／counter Evidence，只描述資源配置 context，不換算成財富分數、報酬率或損失機率。',
      '這項 Evidence 只表示財帛宮生年祿／權值得與空劫、星曜、亮度及其他結構一起閱讀；它不是投資建議，也不代表資產、收入或財務結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_13_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.13.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_12_0.templates,
    'home.stewardship.taiyin':Object.freeze({key:'home.stewardship.taiyin',variants:Object.freeze([
      '田宅宮太陰在《紫微斗數全書》中明確區分入廟與陷地加忌煞的條件；本系統只把這些條件轉成居住／空間穩定與長期維護的支持或反向 Evidence，不預測房產數量、價值或買賣結果。',
      '這項田宅太陰 Evidence 只描述傳統命理中的空間穩定 context：本星亮度有力時增加支持，陷弱且同時見忌或羊陀火鈴空劫時增加阻力；不作不動產投資或資產結果建議。',
      '傳統田宅宮太陰條把亮度與忌煞列為合參條件；產品將其保留成可追溯的支持／counter Evidence，只用於居住與空間維護脈絡，不換算成財富或房產結果。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_14_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.14.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_13_0.templates,
    'social.support_network.tianji':Object.freeze({key:'social.support_network.tianji',variants:Object.freeze([
      '古籍奴僕宮天機條直接區分入廟「得力」與陷弱條件；本系統只把它近似轉成合作／支援網絡可用度的支持或反向 Evidence，不評價朋友忠誠或關係結果。',
      '天機在歷史奴僕宮的亮度條件只被本系統用來描述協作網絡 context：本星有力時增加支持，陷弱時增加反向 Evidence；不把主僕語義套用到現代朋友。',
      '這項人際 Evidence 只表示傳統天機亮度可能改變支援網絡的可用度脈絡，並非友情品質、背叛機率或他人人格評分。',
    ])}),
    'career.role_stability.tianji':Object.freeze({key:'career.role_stability.tianji',variants:Object.freeze([
      '《紫微斗數全書》官祿宮天機條明確區分入廟與陷宮；產品只把這組條件轉成角色穩定與職涯運作的一項支持／counter Evidence，不預測升遷或失業。',
      '官祿宮天機本星亮度有力時，可支持較能維持角色運作的一項傳統職涯 context；亮度偏弱時只降低這項 Evidence，不等同現實職位變動。',
      '這項職涯 Evidence 僅描述傳統命理中的角色穩定脈絡；不把原文古代職位成敗等歷史判語直接轉成現代工作結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_15_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.15.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_14_0.templates,
    'wellbeing.rest_rhythm.taiyin':Object.freeze({key:'wellbeing.rest_rhythm.taiyin',variants:Object.freeze([
      '福德宮太陰入廟與羊陀火鈴空劫在古籍中形成相反的安靜條件；產品只把它轉成休整／內在節奏的支持或反向 Evidence，不衡量幸福或心理健康。',
      '這項太陰 Evidence 只描述傳統福德宮的安定與受阻節奏：亮度有力可增加休整支持，同宮阻力星則保留 counter，不代表睡眠、疾病或情緒診斷。',
      '太陰在福德宮的古典條件被縮減為「較能維持安靜節奏」與「節奏較易被打斷」兩方向 Evidence；不作健康或人生結果預測。',
    ])}),
    'wellbeing.rest_rhythm.tianfu':Object.freeze({key:'wellbeing.rest_rhythm.tianfu',variants:Object.freeze([
      '古籍以「安靜」描述福德宮天府，並列羊陀火鈴空劫等阻力；本系統只保留穩定休整節奏的支持／counter Evidence，不建立幸福或健康分數。',
      '福德宮天府可作為偏向穩定休整的一項傳統 Evidence；若同宮見可驗證的阻力星，則同時保留反向條件，而不是下疾病、壓力或命運結論。',
      '這項天府 Evidence 僅描述內在節奏較穩或較受干擾的文化性 context；不代表心理狀態、睡眠品質、壽命或現實事件。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_16_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.16.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_15_0.templates,
    'home.stewardship.taiyang':Object.freeze({key:'home.stewardship.taiyang',variants:Object.freeze([
      '田宅宮太陽在古籍中明確區分入廟與陷地受阻；產品只將它轉成居住／空間維護穩定度的支持或 counter Evidence，不推算房產數量、價值或投資結果。',
      '這項太陽 Evidence 僅描述傳統田宅宮中較有支持或較受阻的空間維護 context；不代表持有房產、買賣成果或資產變動。',
      '太陽在田宅宮的亮度與同宮阻力條件被縮減為居住／長期維護 Evidence，並不等同房地產預測或重大財務建議。',
    ])}),
    'social.support_network.tiantong':Object.freeze({key:'social.support_network.tiantong',variants:Object.freeze([
      '古籍奴僕宮天同條的旺相與阻力條件，本系統只近似轉成現代合作／支援網絡可用度的支持或 counter Evidence，不對朋友或同事作結果性品格評價。',
      '天同在歷史奴僕宮的條件僅被用來描述協作網絡 context；同宮有力增加支持，同宮阻力星增加反向 Evidence，不預測背叛或關係破裂。',
      '這項人際 Evidence 不沿用古代主僕身分語義，只保留「支援較可用／較受干擾」的低強度傳統脈絡。',
    ])}),
  }),
});
export const INTERP_COMMON_TEMPLATE_PACK_0_17_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.17.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_16_0.templates,
    'wellbeing.rest_rhythm.tianxiang':Object.freeze({key:'wellbeing.rest_rhythm.tianxiang',variants:Object.freeze([
      '福德宮天相在古籍中有較安逸與受羊陀火鈴空劫干擾的兩面條件；產品只保留休整／內在節奏的支持與 counter Evidence，不判斷健康或幸福。',
      '這項天相 Evidence 只描述傳統福德宮較能維持平穩或較易被打斷的節奏，不等同心理狀態、睡眠品質、疾病或壽命。',
      '天相在福德宮的傳統條件被縮減為休整節奏 context；同宮阻力星只降低這項訊號，不代表必然焦慮、疲憊或現實事件。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_18_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.18.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_17_0.templates,
    'wellbeing.rest_rhythm.wenchang':Object.freeze({key:'wellbeing.rest_rhythm.wenchang',variants:Object.freeze([
      '福德宮文昌的入廟加支持星與陷地加羊陀火鈴空劫條件，被縮減為休整／內在節奏的支持或 counter Evidence，不等同心理健康或幸福程度。',
      '這項文昌 Evidence 只在本星亮度與同宮支持／阻力條件可驗證時成立；它描述傳統福德節奏，不推論焦慮、失眠、疾病或壽命。',
      '文昌在福德宮的古典條件只作為平穩休整或較受干擾的一項低強度文化訊號，不把「快樂／不得安靜」直接改寫成醫療或心理判斷。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_19_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.19.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_18_0.templates,
    'wellbeing.rest_rhythm.wuqu':Object.freeze({key:'wellbeing.rest_rhythm.wuqu',variants:Object.freeze([
      '福德宮武曲原文同時保留「勞心費力」與「入廟安然」兩層；產品因此保留基礎 counter，並只在武曲本星亮度有力時加入 supportive Evidence。',
      '這項武曲 Evidence 描述傳統福德宮中較費力但入廟可較安定的節奏；不等同壓力診斷、睡眠品質、疾病、幸福程度或壽命。',
      '武曲在福德宮的古典脈絡不被做成簡單吉凶二分：本星存在保留較需調節的節奏 Evidence，入廟時再增加休整支持，不預測現實結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_20_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.20.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_19_0.templates,
    'wellbeing.rest_rhythm.lucun':Object.freeze({key:'wellbeing.rest_rhythm.lucun',variants:Object.freeze([
      '福德宮祿存原文同時有「安靜處世」與羊陀火鈴空劫造成「不得寧靜」的兩面條件；產品只保留休整／內在節奏的 support 與 counter Evidence。',
      '這項祿存 Evidence 只描述傳統福德宮中較平穩或較受同宮阻力干擾的節奏，不等同幸福、心理健康、睡眠、疾病或壽命判斷。',
      '祿存在福德宮的古典脈絡被縮減成可追溯的休整節奏訊號；同宮羊陀火鈴空劫只降低這項 Evidence，不預測現實事件或健康結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_21_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.21.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_20_0.templates,
    'wellbeing.rest_rhythm.zuofu':Object.freeze({key:'wellbeing.rest_rhythm.zuofu',variants:Object.freeze([
      '福德宮左輔在古籍中以同宮吉星形成較安寧的支持脈絡，羊陀火鈴空劫則增加辛勤條件；產品只保留休整／內在節奏的 support 與 counter Evidence。',
      '這項左輔 Evidence 只在同宮 supporting stars 或原文明列阻力星可驗證時成立，不把晚年、享福、壓力、睡眠、疾病或人生結果直接下結論。',
      '左輔在福德宮的傳統條件被縮減成可追溯的節奏 Evidence：同宮輔助條件增加支持，同宮羊陀火鈴空劫增加反向訊號，不做健康或命運預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_22_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.22.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_21_0.templates,
    'wellbeing.rest_rhythm.youbi':Object.freeze({key:'wellbeing.rest_rhythm.youbi',variants:Object.freeze([
      '福德宮右弼的原典條件同時包含「加吉星」的支持與羊陀火鈴空劫的勞心阻力；產品只保留休整／內在節奏的 support 與 counter Evidence。',
      '這項右弼 Evidence 只在同宮 supporting stars 或原文明列阻力星可驗證時成立，不把福祿、幸福、心理健康、睡眠、疾病或人生結果直接下結論。',
      '右弼在福德宮的傳統條件被縮減成可追溯的節奏 Evidence：同宮輔助條件增加支持，同宮羊陀火鈴空劫增加反向訊號，不做健康或命運預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_23_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.23.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_22_0.templates,
    'home.stewardship.tianxiang':Object.freeze({key:'home.stewardship.tianxiang',variants:Object.freeze([
      '田宅宮天相的「廟旺」條件，本系統只轉成居住／空間維護較有支持的一項低強度 Evidence，不代表一定擁有房產或取得資產。',
      '這項天相 Evidence 僅描述傳統田宅宮中較有延續與維護條件的 context；不推算房產數量、價值、買賣、繼承或投資結果。',
      '天相在田宅宮且本星亮度有力時，只增加一項空間長期維護 support Evidence；它不是不動產預測或重大財務建議。',
    ])}),
    'home.stewardship.tianliang':Object.freeze({key:'home.stewardship.tianliang',variants:Object.freeze([
      '田宅宮天梁入廟旺的古典條件，被縮減為居住／空間維護較具延續性的一項低強度 Evidence，不保留祖業或繼承結果判語。',
      '這項天梁 Evidence 只描述傳統田宅宮較有支持的長期維護 context；不代表房產所有權、數量、價值、繼承或買賣成果。',
      '天梁在田宅宮且本星亮度有力時，本系統只提高空間維護 support 訊號，不把古代祖業語義直接套用到現代資產。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_24_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.24.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_23_0.templates,
    'social.support_network.taiyang':Object.freeze({key:'social.support_network.taiyang',variants:Object.freeze([
      '古籍奴僕宮太陽條的入廟／陷宮差異，本系統只近似轉成合作／支援網絡可用度的 support 或 counter Evidence，不評價朋友忠誠。',
      '這項太陽 Evidence 只描述歷史奴僕宮亮度條件的現代化合作 context：本星有力時增加支持，陷弱時降低這項訊號，不預測特定人際事件或關係結果。',
      '太陽在奴僕宮的古典亮度條件被縮減為低強度人際支援 Evidence；古代主僕的結果性與品格判語不進產品輸出。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_25_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.25.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_24_0.templates,
    'career.role_stability.taiyang':Object.freeze({key:'career.role_stability.taiyang',variants:Object.freeze([
      '官祿宮太陽在古籍中只有入廟且不見羊陀火鈴時形成較乾淨的支持條件；本系統只把它轉成職涯運作較有支撐的一項低強度 Evidence，不代表職位或升遷結果。',
      '這項太陽 Evidence 僅在本星亮度有力且同宮不見羊陀火鈴時成立，描述傳統職涯 context，不推算功名、薪資、錄取或成功機率。',
      '太陽在官祿宮的這條規則只保留原典明示的「入廟＋無四煞」支持結構；若條件不完整就不觸發，也不自行補成負面預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_26_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.26.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_25_0.templates,
    'career.role_stability.tianxiang':Object.freeze({key:'career.role_stability.tianxiang',variants:Object.freeze([
      '官祿宮天相在古籍中明確區分入廟、陷地與同宮阻力條件；本系統只保留角色運作穩定度的 support／counter Evidence，不推算職位、升遷或收入。',
      '這項天相 Evidence 只描述傳統官祿宮的角色承接 context：本星有力增加支持，陷弱或同宮羊陀火鈴空劫增加反向訊號，不等同現實工作結果。',
      '天相在官祿宮的古典條件被拆成可追溯的支持與阻力 Evidence；所有古代官位、食祿與貶謫結果詞皆不作現代預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_27_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.27.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_26_0.templates,
    'career.role_stability.tiantong':Object.freeze({key:'career.role_stability.tiantong',variants:Object.freeze([
      '官祿宮天同只有在本星亮度有力且同宮不見羊陀火鈴時，才形成這條較乾淨的支持 Evidence；它只描述職涯運作 context，不代表職位或升遷結果。',
      '這項天同 Evidence 採用原典明示的「入廟＋無四煞」條件；若條件不足就不觸發，不把含糊的陷宮文字自行擴寫成負面工作預測。',
      '天同在官祿宮的此條規則只保留可驗證的支持結構，並排除薪資、錄取、職稱、成功率與其他確定性職涯結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_28_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.28.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_27_0.templates,
    'social.support_network.wenchang':Object.freeze({key:'social.support_network.wenchang',variants:Object.freeze([
      '文昌在奴僕宮的古典條件只被轉成合作／支援網絡可用度的一項低強度 Evidence；本星有力時偏 support，同宮羊陀火鈴空劫則保留 counter Evidence。',
      '這項文昌 Evidence 僅描述歷史奴僕宮條件在現代合作 context 的近似映射，不做古代主僕品格評價，也不預測朋友或同事關係結果。',
      '文昌在此只作為可追溯的人際支援條件：本星亮度有力提供支持，同宮阻力星增加反向訊號；古代主僕結果性判語不進產品輸出。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_29_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.29.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_28_0.templates,
    'social.support_network.wenqu':Object.freeze({key:'social.support_network.wenqu',variants:Object.freeze([
      '文曲在奴僕宮的古典亮度與同宮阻力條件，只被轉成合作／支援網絡可用度的 support 或 counter Evidence，不作人物品格評價。',
      '這項文曲 Evidence 僅描述歷史奴僕宮條件在現代合作 context 的近似映射：本星有力時偏支持，陷弱或同宮阻力增加反向訊號。',
      '文曲在此只作為可追溯的人際支援條件；古代主僕身分與結果性判語不進產品輸出，也不預測朋友或同事關係結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_30_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.30.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_29_0.templates,
    'home.stewardship.wenchang':Object.freeze({key:'home.stewardship.wenchang',variants:Object.freeze([
      '田宅宮文昌只有在同宮可驗證支持條件或阻力條件出現時才形成 Evidence；產品只描述居住／空間長期維護 context，不推算房產數量或價值。',
      '這項文昌 Evidence 將古典「會諸吉」與羊陀火鈴空劫拆成 support／counter 條件，只保留空間維護脈絡，不延伸成祖產、買賣或投資結果。',
      '文昌在田宅宮的規則只保留可追溯的同宮支持與阻力 Evidence；傳統田產數量、所有權與家產結果判語全部移除。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_31_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.31.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_30_0.templates,
    'home.stewardship.tiantong':Object.freeze({key:'home.stewardship.tiantong',variants:Object.freeze([
      '田宅宮天同的古典結果語被縮減為居住／空間長期維護的一項 support Evidence；同宮羊陀火鈴則保留為額外 counter，不推算田產數量或資產結果。',
      '這項天同 Evidence 只描述空間維護的傳統 context：本星提供低強度支持，同宮四煞增加反向訊號；不涉及房產取得、價值、買賣或繼承。',
      '天同在田宅宮只形成可追溯的維護 Evidence，且羊陀火鈴必須實際同宮才增加 counter；古典「先少後多」不轉成現代房產預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_32_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.32.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_31_0.templates,
    'home.stewardship.wenqu':Object.freeze({key:'home.stewardship.wenqu',variants:Object.freeze([
      '田宅宮文曲的亮度與同宮阻力只被轉成居住／空間長期維護的 support 或 counter Evidence，不代表房產所有權、數量或價值。',
      '這項文曲 Evidence 只保留「旺地」與同宮羊陀火鈴空劫的可驗證條件；古典資產取得與進退等結果詞不進產品輸出。',
      '文曲在田宅宮的規則只描述空間維護 context：本星有力時偏支持，同宮阻力星增加反向訊號；不做房地產或投資結果預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_33_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.33.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_32_0.templates,
    'social.support_network.wuqu':Object.freeze({key:'social.support_network.wuqu',variants:Object.freeze([
      '武曲在歷史奴僕宮只有本星旺宮條件被保留為現代合作／支援網絡的一項低強度 support Evidence；不沿用歷史身分與服從結果語義。',
      '這項武曲 Evidence 只描述本星亮度有力時的合作支援 context，不評價他人品格或權力關係，也不預測朋友或同事結果。',
      '奴僕宮武曲的古典結果詞已被移除；產品只在武曲本星 supportive dignity 時增加可追溯的支援網絡 Evidence。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_34_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.34.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_33_0.templates,
    'home.stewardship.wuqu':Object.freeze({key:'home.stewardship.wuqu',variants:Object.freeze([
      '田宅宮武曲只有在本宮沒有其他主星且武曲亮度符合條件時，才形成這項居住／空間維護 Evidence；有力時偏支持，陷弱時增加反向訊號。',
      '這項武曲 Evidence 保留原典的「單居＋亮度」結構，只描述空間長期維護較順或較需調整，不延伸成房產取得、價值或所有權預測。',
      '武曲在田宅宮的此條規則必須同時符合單一主星與本星亮度條件；產品只呈現可追溯的維護 context，不把傳統家產結果改寫成現代預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_35_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.35.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_34_0.templates,
    'career.role_stability.wenqu':Object.freeze({key:'career.role_stability.wenqu',variants:Object.freeze([
      '官祿宮文曲的本星亮度與同宮阻力被拆成可追溯的 support／counter Evidence；只描述角色運作 context，不代表職位、升遷、錄取或收入結果。',
      '這項文曲 Evidence 只保留原典「廟旺」與羊陀火鈴空劫的客觀條件；有力時偏支持，同宮阻力增加反向訊號，不作傳統職務或現實結果預測。',
      '文曲在官祿宮只形成低強度職涯結構 Evidence；古典結果性職務判語已移除，本項只作為傳統角色運作 context。',
    ])}),
    'career.role_stability.wenchang':Object.freeze({key:'career.role_stability.wenchang',variants:Object.freeze([
      '官祿宮文昌這條規則保留原典的複合條件：文昌本星有力且同宮同時見天府、文曲才形成支持 Evidence；不把文昌單星直接當成職涯結果。',
      '這項文昌 Evidence 必須同時符合本星 supportive dignity、天府與文曲同宮；產品只描述角色運作支援 context，不推算職務結果、升遷、薪資或錄取。',
      '文昌在官祿宮的原典是組合條件，本系統採更保守的三條件觸發；所有傳統身分與成功結果語義均不進產品輸出。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_36_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.36.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_35_0.templates,
    'career.role_stability.zuofu':Object.freeze({key:'career.role_stability.zuofu',variants:Object.freeze([
      '官祿宮左輔的本星亮度與同宮阻力被拆成 support／counter Evidence；只描述角色運作 context，不推導現實職務結果。',
      '這項左輔 Evidence 只保留入廟與同宮羊陀火鈴空劫等可驗證條件；有力時偏支持，同宮阻力增加反向訊號。',
      '左輔在官祿宮只形成低強度職涯結構 Evidence，傳統進退與名聲等結果判語不進產品輸出。',
    ])}),
    'career.role_stability.lucun':Object.freeze({key:'career.role_stability.lucun',variants:Object.freeze([
      '官祿宮祿存只有在同宮出現保守定義的支持星條件時才形成 Evidence；它只描述角色運作較有支撐的傳統 context。',
      '這項祿存 Evidence 將原典「會吉」限制為同宮輔弼、昌曲或魁鉞等可驗證條件，不延伸成現實職務或收入結果。',
      '祿存在官祿宮不能單獨觸發這項解讀；必須有同宮支持星 Evidence，且所有傳統身分與家族結果語義均移除。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_37_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.37.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_36_0.templates,
    'career.role_stability.tianliang':Object.freeze({key:'career.role_stability.tianliang',variants:Object.freeze([
      '官祿宮天梁只有在本星有力且同宮同時具備左右與魁鉞兩類支持條件時，才形成這項較保守的 support Evidence；同宮阻力星另保留 counter。',
      '這項天梁 Evidence 把原典合參條件收斂為可驗證的同宮組合：本星有力、至少一顆左右、至少一顆魁鉞；只描述角色運作 context。',
      '天梁在官祿宮的支持與阻力 Evidence 分開保留；產品不把傳統職務身分或進退結果改寫成現實預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_38_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.38.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_37_0.templates,
    'career.role_stability.wuqu':Object.freeze({key:'career.role_stability.wuqu',variants:Object.freeze([
      '官祿宮武曲的這項 Evidence 只在本星亮度與同宮支持／阻力條件都可驗證時成立；支持條件要求本星有力且同宮見昌曲或左右，反向條件則要求本星陷弱並同宮見陀羅、鈴星或地劫。',
      '這項武曲 Evidence 保留原典的複合結構，但移除古代職務、身分與財富結果；產品只描述角色運作較有支撐或較受干擾的一項傳統 context。',
      '武曲在官祿宮不能只靠單一星曜名稱觸發此規則；必須符合本星亮度與同宮條件，而且「忌」仍維持 Research Hold，不在本批實作。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_39_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.39.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_38_0.templates,
    'career.role_stability.taiyin':Object.freeze({key:'career.role_stability.taiyin',variants:Object.freeze([
      '官祿宮太陰這項 Evidence 只使用本星亮度：有力時提供低強度支持，陷弱時保留反向訊號；不把古典品級或職務結果改寫成現代預測。',
      '這項太陰 Evidence 只描述傳統職涯角色運作 context，並以同星亮度區分 support／counter；其他會合條件需有獨立規則才會加入。',
      '太陰在官祿宮的本批規則只處理可驗證的本星亮度，不推算職位、收入、錄取、升遷或現實成敗。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_40_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.40.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_39_0.templates,
    'wellbeing.rest_rhythm.tiantong':Object.freeze({key:'wellbeing.rest_rhythm.tiantong',variants:Object.freeze([
      '福德宮見天同時，本條只保留較平穩的休整節奏作為低權重傳統依據；不延伸為心理、醫療或人生結果判斷。',
      '天同落在福德宮時，可作為內在節奏較容易回到平穩的一項傳統 Evidence；這不是幸福程度、健康狀態或事件結果的評分。',
      '福德宮天同只提供一項可追溯的休整節奏支持訊號；產品不把古典結果語句直接轉成現代人生預測。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_41_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.41.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_40_0.templates,
    'home.stewardship.lucun':Object.freeze({key:'home.stewardship.lucun',variants:Object.freeze([
      '田宅宮祿存只作為居住／空間長期維護與配置的低權重傳統 Evidence；同宮見羊陀火鈴空劫時另保留維護阻力的 counter Evidence。',
      '祿存落田宅宮的古典條件只被轉譯為空間維持 context；阻力星必須同宮才會形成反向依據。',
      '這組祿存 Evidence 不表示房產數量、價值、所有權或投資結果；只顯示可追溯的傳統維護／配置 context。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_42_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.42.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_41_0.templates,
    'home.stewardship.ziwei':Object.freeze({key:'home.stewardship.ziwei',variants:Object.freeze([
      '田宅宮紫微只作為居住／空間長期維持的傳統 context；自身亮度有力時提供 support，同宮羊陀火鈴空劫則提供 counter Evidence。',
      '這組田宅宮紫微 Evidence 只描述空間維持與配置 context；阻力星必須同宮才會形成反向依據。',
      '紫微在田宅宮的古典條件被限縮為低權重維持 context；不代表房產數量、價值、所有權或買賣結果。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_43_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.43.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_42_0.templates,
    'home.stewardship.tianji':Object.freeze({key:'home.stewardship.tianji',variants:Object.freeze([
      '田宅宮天機在本規則中只代表居住／空間配置較容易重新調整的一項傳統 counter Evidence；不代表必然搬遷、失去房產或任何買賣結果。',
      '天機落田宅宮時，本系統只保留「既有配置較不固定、較可能重新整理」的低權重文化性訊號；不推論所有權、房價或投資結果。',
      '此天機 Evidence 只描述空間維持與重新配置的節奏，不等同房產吉凶、繼承結果或現實交易預測。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_44_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.44.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_43_0.templates,
    'wellbeing.rest_rhythm.tiantong_tianliang':Object.freeze({key:'wellbeing.rest_rhythm.tiantong_tianliang',variants:Object.freeze([
      '福德宮天同與天梁同宮時，可作為休整節奏較易趨於平穩的一項傳統 Evidence；不等同幸福、健康或壽命結論。',
      '這項天同＋天梁 Evidence 只描述福德宮同宮結構所對應的較平穩內在節奏 context，不是心理或醫療判斷。',
      '古籍的「清閑快樂」在本系統只被縮減為低強度休整節奏 support；不用來預測幸福程度或人生結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_45_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.45.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_44_0.templates,
    'wellbeing.rest_rhythm.tiantong_taiyin':Object.freeze({key:'wellbeing.rest_rhythm.tiantong_taiyin',variants:Object.freeze([
      '福德宮天同與太陰同宮時，只作為休整節奏較容易趨於平順的一項低強度傳統 Evidence；不等同幸福、健康或睡眠品質判定。',
      '這項天同會太陰 Evidence 只保留福德宮同宮結構對內在休整節奏的支持 context，不延伸成人生結果或醫療性結論。',
      '古籍「太陰同享福」在產品中被限縮為較平順的休整節奏 support Evidence；不據此推論幸福程度、疾病或壽命。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_46_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.46.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_45_0.templates,
    'wellbeing.rest_rhythm.tianji_tianliang':Object.freeze({key:'wellbeing.rest_rhythm.tianji_tianliang',variants:Object.freeze([
      '福德宮天機與天梁同宮時，只作為休整節奏較容易回到平衡的一項低強度傳統 Evidence；不等同幸福或健康結論。',
      '天機會天梁在本系統只保留為較有利於休整與恢復節奏的 context，不用來判斷心理狀態或人生結果。',
      '古籍「天梁同享福」被限縮成可追溯的內在節奏 support Evidence；不延伸為疾病、睡眠或壽命判定。',
    ])}),
    'wellbeing.rest_rhythm.tianji_taiyin':Object.freeze({key:'wellbeing.rest_rhythm.tianji_taiyin',variants:Object.freeze([
      '福德宮天機與太陰同宮時，只保留較容易形成柔和休整節奏的一項低強度傳統 Evidence；不把「快樂」解讀成心理健康。',
      '這項天機會太陰 Evidence 只描述休整節奏 context，不是幸福分數、睡眠品質或健康預測。',
      '古籍「太陰同主快樂」在產品中只轉成低強度內在節奏 support Evidence，不推論疾病、壽命或人生結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_47_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.47.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_46_0.templates,
    'wellbeing.rest_rhythm.taiyang_taiyin':Object.freeze({key:'wellbeing.rest_rhythm.taiyang_taiyin',variants:Object.freeze([
      '福德宮太陽與太陰同宮時，只保留較容易形成平衡休整節奏的一項低強度傳統 Evidence；不等同幸福或健康結論。',
      '太陽會太陰在本系統只描述內在休整節奏的 support context，不是心理健康、睡眠或人生結果預測。',
      '古籍「太陰同快樂」被限縮為可追溯的休整節奏 Evidence，不轉換成幸福分數、疾病或壽命判定。',
    ])}),
    'wellbeing.rest_rhythm.taiyang_tianliang':Object.freeze({key:'wellbeing.rest_rhythm.taiyang_tianliang',variants:Object.freeze([
      '福德宮太陽與天梁同宮時，只作為休整節奏較容易回穩的一項低強度傳統 Evidence；不等同心理或健康判定。',
      '這項太陽會天梁 Evidence 只保留內在節奏 support context，不用來判斷幸福程度、睡眠或人生結果。',
      '古籍「天梁同快樂」在產品中只轉成低強度休整節奏 Evidence，不推論疾病、壽命或心理健康。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_48_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.48.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_47_0.templates,
    'wellbeing.rest_rhythm.tianfu_ziwei':Object.freeze({key:'wellbeing.rest_rhythm.tianfu_ziwei',variants:Object.freeze([
      '\u798f\u5fb7\u5bae\u5929\u5e9c\u8207\u7d2b\u5fae\u540c\u5bae\u6642\uff0c\u53ea\u4f5c\u70ba\u4f11\u6574\u7bc0\u594f\u8f03\u5bb9\u6613\u56de\u7a69\u7684\u4e00\u9805\u4f4e\u5f37\u5ea6\u50b3\u7d71 Evidence\uff1b\u4e0d\u7b49\u540c\u5e78\u798f\u6216\u5065\u5eb7\u7d50\u8ad6\u3002',
      '\u5929\u5e9c\u6703\u7d2b\u5fae\u5728\u672c\u7cfb\u7d71\u53ea\u4fdd\u7559\u5167\u5728\u4f11\u6574\u7bc0\u594f\u7684 support context\uff0c\u4e0d\u662f\u5fc3\u7406\u5065\u5eb7\u3001\u7761\u7720\u54c1\u8cea\u6216\u4eba\u751f\u7d50\u679c\u9810\u6e2c\u3002',
      '\u53e4\u7c4d\u300c\u7d2b\u5fae\u540c\u5feb\u6a02\u300d\u5728\u7522\u54c1\u4e2d\u53ea\u88ab\u7e2e\u6e1b\u70ba\u4f4e\u5f37\u5ea6\u4f11\u6574\u7bc0\u594f Evidence\uff0c\u4e0d\u63a8\u8ad6\u5e78\u798f\u7a0b\u5ea6\u3001\u75be\u75c5\u6216\u58fd\u547d\u3002',
    ])}),
    'wellbeing.rest_rhythm.tianji_taiyin':Object.freeze({key:'wellbeing.rest_rhythm.tianji_taiyin',variants:Object.freeze([
      '\u798f\u5fb7\u5bae\u5929\u6a5f\u8207\u592a\u9670\u540c\u5bae\u6642\uff0c\u540c\u66f8\u540c\u6642\u7559\u6709\u4f11\u6574\u652f\u6301\u8207\u300c\u5fc3\u5fd9\u300d\u5169\u9762\u63cf\u8ff0\uff1b\u672c\u7cfb\u7d71\u4fdd\u7559 support \u8207 counter Evidence\uff0c\u4e0d\u5f37\u884c\u5408\u4f75\u6210\u55ae\u4e00\u597d\u58de\u7d50\u8ad6\u3002',
      '\u5929\u6a5f\u6703\u592a\u9670\u7684\u798f\u5fb7 Evidence \u5728\u53e4\u7c4d\u4e2d\u4e26\u975e\u55ae\u5411\uff1a\u53ef\u540c\u6642\u6709\u8f03\u67d4\u548c\u7684\u4f11\u6574 context \u8207\u5167\u5728\u7bc0\u594f\u8f03\u5fd9\u7684\u53cd\u5411\u8a0a\u865f\uff1b\u9019\u4e0d\u662f\u5fc3\u7406\u6216\u91ab\u7642\u5224\u65b7\u3002',
      '\u53e4\u7c4d\u5206\u5225\u6709\u300c\u592a\u9670\u540c\u4e3b\u5feb\u6a02\u300d\u8207\u300c\u5929\u6a5f\u540c\u5fc3\u5fd9\u300d\uff1b\u7522\u54c1\u53ea\u5c07\u5176\u8f49\u6210\u53ef\u8ffd\u6eaf\u7684\u4f11\u6574\u7bc0\u594f\u6b63\u53cd Evidence\uff0c\u4e0d\u5ef6\u4f38\u70ba\u7126\u616e\u3001\u5931\u7720\u3001\u75be\u75c5\u6216\u5e78\u798f\u5206\u6578\u3002',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_49_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.49.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_48_0.templates,
    'wellbeing.rest_rhythm.ziwei':Object.freeze({key:'wellbeing.rest_rhythm.ziwei',variants:Object.freeze([
      '福德宮紫微只作為休整與內在節奏較能維持穩定的一項傳統 Evidence；同宮羊、陀、鈴、空、劫會加入反向依據。',
      '紫微在福德宮的古典脈絡只被限縮為低強度休整節奏 support；若同宮見原文列出的阻力星，則同時保留 counter Evidence。',
      '這項紫微 Evidence 不代表幸福程度、心理健康、睡眠品質、疾病或壽命；只描述傳統命理中的內在節奏 context。',
    ])}),
    'wellbeing.rest_rhythm.ziwei_tianxiang':Object.freeze({key:'wellbeing.rest_rhythm.ziwei_tianxiang',variants:Object.freeze([
      '福德宮紫微與天相同宮時，可增加一項較有利於休整節奏的低強度傳統 Evidence；不延伸成終身吉凶或幸福結果。',
      '紫微會天相在本系統只保留為內在節奏 support context，不是心理、醫療或人生結果判定。',
    ])}),
    'wellbeing.rest_rhythm.ziwei_tianji':Object.freeze({key:'wellbeing.rest_rhythm.ziwei_tianji',variants:Object.freeze([
      '福德宮紫微與天機同宮時，只加入一項休整節奏較容易維持的低強度傳統 Evidence；不保留終身福分等結果性語義。',
      '紫微會天機在本系統只表示可追溯的休整節奏 support context，不是幸福分數、睡眠或健康預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_50_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.50.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_49_0.templates,
    'social.support_network.ziwei':Object.freeze({key:'social.support_network.ziwei',variants:Object.freeze([
      '古籍奴僕宮紫微的「得力」只被轉成現代協作／支援網絡可用度的一項低強度 Evidence；同宮羊、陀、火、鈴會加入反向依據。',
      '紫微落僕役／朋友宮時，本系統只描述支援網絡 context；不把古代奴僕關係直接等同現代友情，也不判斷忠誠或背叛。',
    ])}),
    'social.support_network.ziwei_tianxiang':Object.freeze({key:'social.support_network.ziwei_tianxiang',variants:Object.freeze([
      '紫微與天相同居僕役／朋友宮時，可增加一項協作支援較易成形的傳統 Evidence；若同宮空劫，則同時保留反向訊號。',
      '這組紫微＋天相只描述支援網絡的結構性 context，不代表他人可靠、關係長久或現實互動結果。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_51_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.51.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_50_0.templates,
    'wellbeing.rest_rhythm.tianfu_tianxiang':Object.freeze({key:'wellbeing.rest_rhythm.tianfu_tianxiang',variants:Object.freeze([
      '福德宮天府與天相同宮時，只加入一項較有利於休整節奏的低強度傳統 Evidence；不等同幸福或健康結論。',
      '天府會天相在本系統只描述較平穩的內在休整 context，不是心理、睡眠、疾病或壽命預測。',
    ])}),
    'wellbeing.rest_rhythm.tianfu_lucun':Object.freeze({key:'wellbeing.rest_rhythm.tianfu_lucun',variants:Object.freeze([
      '福德宮天府與祿存同宮時，只保留較平順休整節奏的一項低強度傳統 Evidence；不把「快樂」換算成幸福分數。',
      '這項天府＋祿存 Evidence 只描述內在休整 context，不推論心理健康、睡眠、疾病、壽命或人生結果。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_52_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.52.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_51_0.templates,
    'social.support_network.tianliang':Object.freeze({key:'social.support_network.tianliang',variants:Object.freeze([
      '天梁落在僕役／朋友宮時，只保留一項合作／支援網絡可用度的低強度傳統 Evidence；同宮天同可增加支持，同宮天機則保留協作節奏不一致的反向訊號。',
      '古籍天梁奴僕宮條文在產品中只轉成現代支援網絡 context；不把古代主僕關係等同友情，也不判斷忠誠、背叛或關係成敗。',
      '這組天梁 Evidence 同時允許 support 與 counter 並存，僅反映可追溯的協作條件，不是朋友可靠度、團隊成功率或人際結果評分。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_53_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.53.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_52_0.templates,
    'home.stewardship.qingyang':Object.freeze({key:'home.stewardship.qingyang',variants:Object.freeze([
      '田宅宮擎羊在陷弱且同宮見空劫時，本系統只保留為居住／空間維護比較容易反覆調整的一項 counter Evidence；不推論失去房產、資產價值或所有權。',
      '這組擎羊＋空劫條件只描述空間配置、維護與穩定性較需要多一層調整的傳統 context，不等於房產損失或不動產投資結果。',
      '古籍田宅宮的「陷地加空劫」在產品中被限縮成居住環境較容易出現重整需求的反向 Evidence，不延伸為祖產、買賣、財富或必然事件。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_54_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.54.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_53_0.templates,
    'family.sibling_coordination.context':Object.freeze({key:'family.sibling_coordination.context',variants:Object.freeze([
      '這一項主要看近身家人或手足之間怎麼溝通、分工與調整彼此節奏。天機出現在這個位置時，比較值得注意的是事情一變，角色與做法也容易跟著重排；重點不在親疏好壞，而在能不能把需求講清楚、留出協調空間。',
      '家庭互動的重點較偏向「怎麼協調」而不是誰對誰錯。遇到安排改變、責任重新分配或意見不同時，你可能比較需要透過多次溝通把彼此的位置重新排好；若亮度另有支持或阻力，系統會再分開補上。',
      '這個家庭訊號可理解為：近身家人的互動比較容易隨情境調整，固定分工未必一直適用。真正有用的做法是把責任、界線與臨時變動說清楚，而不是把一次摩擦直接當成關係好壞。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_55_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.55.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_54_0.templates,
    'family.support_availability.ziwei':Object.freeze({key:'family.support_availability.ziwei',variants:Object.freeze([
      '兄弟宮紫微的原典有「倚靠」脈絡；本系統只把它轉成近身家庭／手足在需要時較可能形成可用支援的一項低強度 Evidence，不代表關係一定親密，也不推論手足人數、年齡或家庭結果。',
      '這項 Family Evidence 看的不是家人感情好不好，而是遇到事情時，近身家庭或手足之間是否較容易形成一個可以實際依靠、互相補位的支援點；古籍的人數與長幼結果語義不進產品輸出。',
      '依卷二兄弟宮紫微條，本系統只保留「需要時較可能有支援可用」的文化性訊號。它不等同親密度、忠誠度、誰一定幫誰，也不預測家庭事件或人生結果。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_56_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.56.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_55_0.templates,
    'relationship.partner_support.tianji_taiyin':Object.freeze({key:'relationship.partner_support.tianji_taiyin',variants:Object.freeze([
      '夫妻宮天機與太陰同宮的古籍有「內助」脈絡；本系統只把它轉成關係中實際需要時較可能形成補位、協助承接或支援的一項低強度 Evidence，不保留美容、性別角色、配偶年齡或婚姻結果。',
      '這項伴侶 Evidence 看的不是感情好壞，而是事情真的需要協助時，兩人之間是否較容易形成可用的實際支援；古籍的外貌、性別與婚姻結果語義全部不進產品輸出。',
      '依卷二夫妻宮天機與太陰同宮條，本系統只保留「需要時較可能有實際補位可用」的文化性訊號；它不代表誰必須照顧誰，也不預測關係長久、婚姻成敗或特定事件。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_57_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.57.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_56_0.templates,
    'relationship.reciprocity.tianxiang':Object.freeze({key:'relationship.reciprocity.tianxiang',variants:Object.freeze([
      '夫妻宮天相在本系統只保留一項「關係中的分寸、交換與角色期待需要有共同標準」的低強度文化性訊號；不把星曜直接當成配偶人格，也不推論婚姻成敗。',
      '這項伴侶 Evidence 主要用來觀察雙方怎麼理解責任、公平與互相承擔；公平不等於每件事平均，而是分配理由能被雙方理解，負荷改變時也可以重新協商。',
      '依卷二夫妻宮天相條與卷一天相星性的共同脈絡，產品只抽象為較重視分寸、誠實說明與合理交換的一項關係閱讀線索；外貌、階級、婚期與結果判語全部移除。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_58_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.58.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_57_0.templates,
    'social.collaboration_alignment.tianliang_tianji':Object.freeze({key:'social.collaboration_alignment.tianliang_tianji',variants:Object.freeze([
      '古籍以「不一心」描述這組奴僕宮條件；本系統只把它限縮成合作時節奏、優先順序或做法較容易不同步的一項低強度 Evidence，不推論任何人的忠誠、人格或關係結果。',
      '這項人際 Evidence 看的是合作是否容易各自照自己的節奏前進；真正值得觀察的是資訊、時點與分工有沒有先對齊，而不是把差異解讀成誰不可靠。',
      '依卷二奴僕宮天梁條，本系統只保留「合作步調較需要先對焦」的文化性訊號；它不代表友情成敗，也不預測背叛、離散或特定人際事件。',
    ])}),
    'social.collaboration_alignment.tianji_taiyin':Object.freeze({key:'social.collaboration_alignment.tianji_taiyin',variants:Object.freeze([
      '古籍在天機與太陰同居奴僕宮時明列「欠力」；本系統只把它限縮成合作時資訊、節奏或分工方式較需要事前對焦的一項低強度 Evidence，不保留主僕或結果判語。',
      '這項人際 Evidence 不是在判斷朋友好不好，而是在提醒合作若缺少共同節奏，支援即使存在也可能接不上；先確認需求、時點與交接方式會更實際。',
      '依卷二奴僕宮天機與太陰條，本系統只保留「合作前需要較明確對焦」的文化性訊號；不推論忠誠、人格、友情成敗或必然事件。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_59_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.59.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_58_0.templates,
    'family.support_availability.assistants':Object.freeze({key:'family.support_availability.assistants',variants:Object.freeze([
      '兄弟宮左輔或右弼在本系統只保留為近身家庭需要時較可能形成實際補位的一項低強度 Evidence；若同宮見空劫，則改以「支援較需要重新對焦」的反向條件處理。',
      '這項家庭 Evidence 看的是事情真的來了，近身家人之間的協助能不能接上；空劫同見時重點放在責任、資訊與可幫到哪裡需要說得更清楚，而不是判斷感情好壞。',
      '依卷二兄弟宮左輔、右弼條，本系統只抽象出「實際支援可用度」；手足人數、長幼、刑剋、親疏與家庭結果全部不進產品輸出。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_60_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.60.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_59_0.templates,
    'family.boundary_space.tiantong_obstruction':Object.freeze({key:'family.boundary_space.tiantong_obstruction',variants:Object.freeze([
      '兄弟宮天同同見羊陀火鈴空劫的古籍有「宜分居不和」語句；產品只把它縮減為共同生活時空間與責任界線較需要事前安排的 counter Evidence。',
      '這項家庭 Evidence 不代表需要真的分居，而是提醒近身家人若長時間共用空間、物品或責任，較值得把各自可用範圍、交接與打擾界線先講清楚。',
      '原典的結果性「分居／不和」在產品中不直接使用；只保留可驗證的同宮阻力條件，轉成近身家庭共處界線較需要調整的一項低強度文化訊號。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_61_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.61.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_60_0.templates,
    'relationship.continuity.tianfu':Object.freeze({key:'relationship.continuity.tianfu',variants:Object.freeze([
      '夫妻宮天府在本系統只保留為「關係需要靠日常照應與持續投入來維持」的一項低強度 Evidence；不把古籍的諧老直接翻成婚姻確定長久結果。',
      '這項感情 Evidence 看的是平常能不能持續照顧共同生活的小事、承諾與節奏，而是觀察共同生活的維持方式，不把它當成人生結果預測。',
      '依卷二夫妻宮天府條，本產品只抽象出關係維持與日常照應的文化性訊號；婚期、長久、富貴、配偶人格與成敗結果全部不進輸出。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_62_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.62.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_61_0.templates,
    'relationship.continuity.tiantong':Object.freeze({key:'relationship.continuity.tiantong',variants:Object.freeze([
      '夫妻宮天同在產品中只保留為「共同生活比較需要穩定節奏與可持續照應」的一項低強度訊號；若同宮另見羊、陀、火、鈴，則把需要重新協調的條件一併保留。',
      '這組 Evidence 重點不是婚姻長短，而是兩個人能否把日常安排、責任分工與互相補位維持成可持續的節奏；遇到壓力條件時，更需要把默契改成可說清楚的做法。',
      '產品對夫妻宮天同採保守解讀：看共同生活是否容易建立可延續的節奏，也看同宮四煞是否增加協調成本；不輸出具體婚期、分離事件或關係結果預測。',
    ])}),
  }),
});

export const INTERP_COMMON_TEMPLATE_PACK_0_63_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.63.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_62_0.templates,
    'family.boundary_space.taiyin_obstruction':Object.freeze({key:'family.boundary_space.taiyin_obstruction',variants:Object.freeze([
      '兄弟宮太陰同見羊陀火鈴空劫時，本產品只保留「近身家庭共處界線需要更清楚」的一項低強度反向訊號；不沿用舊式結果、分離安排或數量判語。',
      '這項家庭訊號看的不是家人會不會疏遠，而是長時間共用空間、物品、時間或責任時，界線是否容易被熟悉感省略；越早把使用與交接規則說清楚，越能降低反覆摩擦。',
      '原典對兄弟宮太陰加羊陀火鈴空劫使用結果性語句；產品只轉成可驗證的共處界線提醒，不輸出必然分離、關係成敗或數量結果。',
    ])}),
  }),
});


export const INTERP_COMMON_TEMPLATE_PACK_0_64_0: TemplatePack = Object.freeze({id:'TEMPLATE-COMMON-ZHTW',version:'0.64.0',templates:Object.freeze({...INTERP_COMMON_TEMPLATE_PACK_0_63_0.templates,'mobility.external_adaptation.major_star':Object.freeze({key:'mobility.external_adaptation.major_star',variants:Object.freeze(['遷移宮這組訊號只用來觀察你進入外部環境、移動或換場時，能否重新讀懂規則並建立可運作的節奏；不把古籍的財祿、貴人或吉凶結果直接搬進現代解讀。','這項遷移 Evidence 看的是環境一換之後的適應方式：如何取得資訊、找到可用資源、調整原本做法並重新進入狀態，而不是預測旅行、搬遷或外出事件的好壞。','依卷二遷移宮多條主星共同脈絡，產品只保留「外部環境切換與移動節奏」這層文化性訊號；不輸出發財、災禍、是非或必然事件判語。'])})})});

export const INTERP_COMMON_TEMPLATE_PACK_0_65_0: TemplatePack = Object.freeze({id:'TEMPLATE-COMMON-ZHTW',version:'0.65.0',templates:Object.freeze({...INTERP_COMMON_TEMPLATE_PACK_0_64_0.templates,'mobility.external_adaptation.obstruction':Object.freeze({key:'mobility.external_adaptation.obstruction',variants:Object.freeze([
  '當遷移宮的主星同見來源明載的煞曜組合時，本產品只保留一個很實際的提醒：環境一換，先別急著照原本節奏硬推，最好先確認規則、資源與合作介面，再重新安排步調。',
  '這項反向訊號不是在預測外出會出事，而是指出陌生場域、移動或工作切換時，資訊落差與節奏磨合可能更值得注意；預留緩衝、先問清楚再動手，通常比臨場硬撐更合適。',
  '原典使用不安、是非或少遂志等結果語；產品已移除這些判語，只轉成「換場後需要較多校準與緩衝」的文化性 Evidence，不輸出災禍、成敗、財運或確定事件結果。',
])})})});

export const INTERP_COMMON_TEMPLATE_PACK_0_66_0: TemplatePack = Object.freeze({id:'TEMPLATE-COMMON-ZHTW',version:'0.66.0',templates:Object.freeze({
  ...INTERP_COMMON_TEMPLATE_PACK_0_65_0.templates,
  'mobility.external_support_coordination.secondary_support':Object.freeze({key:'mobility.external_support_coordination.secondary_support',variants:Object.freeze([
    '遷移宮見文昌、文曲、左輔、右弼或祿存時，本產品只保留一項低強度訊號：換到外部環境後，較值得留意資訊來源、聯絡窗口與合作接點是否容易建立；不把古籍的貴人、財祿或發達語句直接搬入解讀。',
    '這項遷移 Evidence 看的是「外部支援能不能接得上」：在陌生場域、跨團隊或移動情境中，能否較快找到誰可以提供資訊、哪個資源可用，以及事情應從哪個接口往下推。',
    '依卷二遷移宮文昌、文曲、左輔、右弼、祿存條，產品只抽象出外部資訊與合作介面的可用度；不推論人脈多寡、貴人運、財運或必然事件結果。',
  ])}),
  'mobility.external_support_coordination.obstruction':Object.freeze({key:'mobility.external_support_coordination.obstruction',variants:Object.freeze([
    '若上述外部支援星曜同見原典明載的羊陀火鈴或空劫組合，產品只把它轉成一個操作提醒：外部合作前更需要確認誰負責、資訊從哪裡來、交接到哪裡算完成。',
    '這項反向訊號不是在說外出一定有人阻礙，而是提醒換場後的聯絡點、責任邊界或資訊版本可能更需要核對；先建立單一窗口與明確交接，比臨場靠默契更穩。',
    '原典中的欠安寧、爭競、是非或不足意等結果語已移除；產品只保留「外部支援介面需要更多校準」的低強度 Evidence，不輸出人際成敗、災禍或財務結果。',
  ])}),
})});

export const INTERP_COMMON_TEMPLATE_PACK_0_67_0: TemplatePack = Object.freeze({
  id:'TEMPLATE-COMMON-ZHTW', version:'0.67.0', templates:Object.freeze({
    ...INTERP_COMMON_TEMPLATE_PACK_0_66_0.templates,
    'wealth.resource_retention.tianxiang':Object.freeze({key:'wealth.resource_retention.tianxiang',variants:Object.freeze([
      '財帛宮天相在原典帶有積聚脈絡；本產品只把它轉成「資源是否容易留下緩衝、維持配置」的一項低強度 Evidence，不把富足或成敗直接當成財務結果。',
      '這項天相 Evidence 看的是資源留存方式：收入、時間或可用資源進來之後，是否較容易先保留一部分餘裕，再安排後續用途；若同宮另見來源明載的阻力條件，則同時保留較難維持緩衝的反向訊號。',
      '依《紫微斗數全書》財帛宮天相條，產品只保留「積聚／留存秩序」這層文化性訊號；不輸出收入高低、資產多寡、投資報酬、破財或發財預測。',
    ])}),
  }),
});
